export default {
  // Acciones y mensajes genericos del visor de recursos
  cancel: 'Cancelar',
  confirm: 'Confirmar',
  save: 'Guardar',
  resources: 'Recursos',
  description: 'Descripción',
  default_description: 'El recurso no contiene descripción.',
  confirm_delete: 'Estás por eliminar un recurso ¿Deseas continuar?',
  loading: 'Cargando recursos, por favor espere...',
  external_resource: 'Este recurso no puede ser mostrado dentro de la app, para verlo por favor presione el botón '
    + '"descargar" para abrirlo en el navegador.',

  // Formulario de creacion de un recurso
  create: {
    name: 'Nombre',
    description: 'Descripción',
    resource_type: 'Selecciona el tipo de recurso',
    resource_file: 'Selecciona un archivo',
    assign_to: 'Asignar a',
    non_resource_file: 'No se ha seleccionado un archivo.',
    resource_location: 'Seleccione ubicaciones',
    resource_roles: 'Seleccione roles'
  },

  // Opciones de tipo de recurso y alcance (radio buttons)
  radio: {
    img: 'Imágen',
    doc: 'Documento',
    video: 'Vídeo',
    all_usr: 'Todos los usuarios',
    locations: 'Ubicaciones',
    roles: 'Roles'
  },

  // Validaciones del formulario de creacion
  upload_by_role: {
    setting: 'En Recursos, "Subir a todas las ubicaciones" sube solo a las ubicaciones donde el usuario tiene rol.',
    checkbox_all: 'Subir a todas las ubicaciones',
    checkbox: 'Subir a todas mis ubicaciones',
    saved: 'El documento se guardó correctamente.',
    updated: 'El documento se actualizó en tus ubicaciones del subgrupo correctamente.',
    no_locations: 'No tienes rol en ninguna ubicación de esta carpeta.'
  },
  validate: {
    file: 'No se ha seleccionado un archivo',
    name: 'No se ha introducido un nombre',
    description: 'No se ha introducido una descripción'
  }
}
